/**
 * Meta Pixel tracking utility functions
 * Used to track custom events throughout the application
 */

// Check if Meta Pixel (fbq) is available
const isMetaPixelAvailable = () => {
  return typeof window !== "undefined" && window.fbq;
};

// Track standard events
export const trackEvent = (eventName, parameters = {}) => {
  if (isMetaPixelAvailable()) {
    window.fbq("track", eventName, parameters);
    console.log(`Meta Pixel: Tracked ${eventName}`, parameters);
  } else {
    console.log(
      `Meta Pixel not available. Would track: ${eventName}`,
      parameters
    );
  }
};

// Track custom events
export const trackCustomEvent = (eventName, parameters = {}) => {
  if (isMetaPixelAvailable()) {
    window.fbq("trackCustom", eventName, parameters);
    console.log(`Meta Pixel: Tracked custom ${eventName}`, parameters);
  } else {
    console.log(
      `Meta Pixel not available. Would track custom: ${eventName}`,
      parameters
    );
  }
};

// Standard eCommerce events for medical/aesthetic clinic
export const metaPixelEvents = {
  // Track page views (already handled automatically)
  trackPageView: () => trackEvent("PageView"),

  // Track when user views treatment details
  trackViewContent: (treatmentName, treatmentCategory) => {
    trackEvent("ViewContent", {
      content_name: treatmentName,
      content_category: treatmentCategory,
      content_type: "treatment",
    });
  },

  // Track contact form submissions
  trackLead: (formType = "contact") => {
    trackEvent("Lead", {
      content_name: formType,
      content_category: "contact",
    });
  },

  // Track contact form starts
  trackInitiateCheckout: (formType = "contact") => {
    trackEvent("InitiateCheckout", {
      content_name: formType,
      content_category: "contact_form",
    });
  },

  // Track before/after image views
  trackViewContentImages: (treatmentName) => {
    trackCustomEvent("ViewBeforeAfterImages", {
      treatment_name: treatmentName,
      content_type: "before_after_images",
    });
  },

  // Track treatment category browsing
  trackSearch: (searchTerm) => {
    trackEvent("Search", {
      search_string: searchTerm,
    });
  },

  // Track contact information views
  trackContactInfoView: () => {
    trackCustomEvent("ViewContactInfo", {
      content_category: "contact_info",
    });
  },

  // Track phone number clicks
  trackPhoneClick: () => {
    trackCustomEvent("PhoneClick", {
      event_type: "phone_click",
      content_category: "contact",
    });
  },

  // Track map/location views
  trackLocationView: () => {
    trackCustomEvent("ViewLocation", {
      content_category: "location",
    });
  },

  // Track about page views
  trackAboutView: () => {
    trackCustomEvent("ViewAbout", {
      content_category: "about",
    });
  },
};

export default metaPixelEvents;
